<template>
  <div class="">
    <van-popup
      v-model="show"
      round
      :closeable="isShowClose"
      position="bottom"
      close-icon-position="top-right"
      :style="{ height: showHeigth }"
      get-container="body"
    >
      <slot></slot>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Popup3',
  props: {
    showPopup: {
      type: Boolean,
      default: false
    },
    showHeigth: {
      type: String,
      default: '90%'
    },
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    show: {
      get () {
        return this.showPopup
      },
      set (val) {
        this.$emit('close-popup')
      }
    }
  }
}
</script>

<style lang="less" scoped>


</style>



// WEBPACK FOOTER //
// src/modules/Popup3/index.vue